import Image from "next/image"
import { Anchor } from "../../app/components/anchor"
import { shuffleArray } from "../../util/array"

const links = [
  {
    title: "10 Do’s and Dont’s for Shipping Your Pet",
    alt: "Checklist for pet shipping",
    imagePath: "/images/pet-ship-dos-and-donts-blog.webp",
    link:
      "https://citizenshipper.com/blog/dos-and-donts-for-shipping-your-pet/",
  },
  {
    title: "Things to look for in a driver when transporting your pet",
    imagePath: "/images/pet-ship-look-for-blog.webp",
    alt: "Choosing a pet transport driver",
    link:
      "https://citizenshipper.com/blog/things-to-look-for-in-a-driver-when-transporting-your-pet/",
  },
  {
    title: "How to prepare your pet for a long ride",
    imagePath: "/images/pet-ship-prepare-blog.webp",
    alt: "Preparing a pet for travel",
    link: "https://citizenshipper.com/blog/prepare-pet-long-ride/",
  },
  {
    title: "Understanding pet transportation protection plans",
    imagePath: "/images/pet-ship-protection-plans-blog.webp",
    alt: "Pet transport protection plans",
    link:
      "https://citizenshipper.com/blog/understanding-pet-transportation-protection-plans/",
  },
  {
    title: "Best Pet Shipping Companies in the USA",
    link:
      "https://citizenshipper.com/blog/best-pet-shipping-companies-in-the-usa/",
    imagePath: "/images/best-shipping.webp",
    alt: "best shipping",
  },
  {
    title: "Best Dog Shipping Companies in the USA",
    link: "https://citizenshipper.com/blog/best-dog-shipping-companies/",
    imagePath: "/images/shipping-companies.webp",
    alt: "shipping companies",
  },
  {
    title: "Best Pet Transport Services",
    link: "https://citizenshipper.com/blog/best-pet-transport-services/",
    imagePath: "/images/transport-petss.webp",
    alt: "ship pets",
  },
  {
    title: "Flying Your Dog by Air in 2023: What Airlines Offer Cargo Options",
    link:
      "https://citizenshipper.com/blog/flying-your-dog-by-air-in-2023-what-airlines-offer-cargo-options/",
    imagePath: "/images/cargo.webp",
    alt: "cargo options",
  },
  {
    title: "What Airlines Allow Pets to Fly Alone",
    link:
      "https://citizenshipper.com/blog/what-airlines-allow-pets-to-fly-alone/",
    imagePath: "/images/flyy-alone.webp",
    alt: "Pet fly alone",
  },
  {
    title: "Cost of Flying a Dog Internationally: What to Expect",
    link:
      "https://citizenshipper.com/blog/cost-of-flying-a-dog-internationally-what-to-expect/",
    imagePath: "/images/what-too-expect.webp",
    alt: "what to expect",
  },
  {
    title: "How to Transport a Cat Without Carrier",
    link:
      "https://citizenshipper.com/blog/how-to-transport-a-cat-without-carrier/",
    imagePath: "/images/cat-without-a-carrier.webp",
    alt: "Cat without carrier",
  },
  {
    title:
      "Become a Flight Nanny: A Unique Opportunity to Fly Pets Safely Home",
    link: "https://citizenshipper.com/blog/air-nanny/",
    imagePath: "/images/air-nanny.webp",
    alt: "air nanny",
  },
  {
    title: "USDA Certified Pet Transporter",
    link: "https://citizenshipper.com/blog/usda-certified-pet-transporter/",
    imagePath: "/images/usda-certified.webp",
    alt: "usda-certified",
  },
  {
    title: "How to Ship a Dog to Another State",
    link: "https://citizenshipper.com/blog/how-to-ship-a-dog-to-another-state/",
    imagePath: "/images/ship-my-dog-to-another-state.webp",
    alt: "Ship pet to Another State",
  },
  {
    title: "How Much Does It Cost to Ship a Dog by Itself",
    link:
      "https://citizenshipper.com/blog/how-much-does-it-cost-to-ship-a-dog-by-itself/",
    imagePath: "/images/ship-a-dog-by-itself.webp",
    alt: "Cost to Ship a Dog",
  },
  {
    title: "Cost per Mile to Ship a Dog",
    link: "https://citizenshipper.com/blog/cost-per-mile-to-ship-a-dog/",
    imagePath: "/images/per-mile-to-ship.webp",
    alt: "cost per mile",
  },
  {
    title: "Cheapest Way to Transport a Dog Across the Country",
    link:
      "https://citizenshipper.com/blog/cheapest-way-to-transport-a-dog-across-the-country/",
    imagePath: "/images/-across-the-country.webp",
    alt: "cheapest way to transport a dog",
  },
  {
    title: "Cost to Fly a Dog",
    link: "https://citizenshipper.com/blog/cost-to-fly-a-dog/",
    imagePath: "/images/fly-a-dog.webp",
    alt: "fly a dog",
  },
  {
    title: "Pet Transport Cost Calculator",
    link: "https://citizenshipper.com/blog/pet-transport-cost-calculator/",
    imagePath: "/images/cost-calculator.webp",
    alt: "cost calculator",
  },
  {
    imagePath: "/images/is-it-safe.webp",
    alt: "ship pet by air",
    title: "Flying Your Dog in Cargo: Is It Safe?",
    link:
      "https://citizenshipper.com/blog/flying-your-dog-in-cargo-is-it-safe/",
  },
  {
    imagePath: "/images/fedex-pet-shipping.webp",
    alt: "pet shipping",
    title: "FedEx Pet Shipping",
    link: "https://citizenshipper.com/blog/fedex-pet-shipping/",
  },
  {
    imagePath: "/images/from-flying.webp",
    alt: "Restricted from flying",
    title: "Dog Breeds Restricted from Flying",
    link: "https://citizenshipper.com/blog/dog-breeds-restricted-from-flying/",
  },
  {
    imagePath: "/images/pets-unaccompanied.webp",
    alt: "Pets unaccompanied",
    title: "Airlines That Fly Pets Unaccompanied",
    link:
      "https://citizenshipper.com/blog/airlines-that-fly-pets-unaccompanied/",
  },
  {
    title: "How to Ship a Cat by Air and Costs",
    imagePath: "/images/air-and-costs.webp",
    alt: "ship pet by air",
    link: "https://citizenshipper.com/blog/how-to-ship-a-cat-by-air-and-costs/",
  },

  {
    title: "10 Best Cars for Transporting Dogs",
    imagePath: "/images/transporting-dogs.webp",
    alt: "transporting-dogs",
    link: "https://citizenshipper.com/blog/10-best-cars-for-transporting-dogs/",
  },
  {
    title: "How Do Dogs Get Shipped on Planes",
    imagePath: "/images/on-planes.webp",
    alt: "shipped on planes",
    link: "https://citizenshipper.com/blog/how-do-dogs-get-shipped-on-planes/",
  },

  {
    title: "How to Ship Animals to Another State",
    imagePath: "/images/another-state.webp",
    alt: "another state",
    link:
      "https://citizenshipper.com/blog/how-to-ship-animals-to-another-state/",
  },

  {
    title: "Pet Shipping Cost Estimate: Cats and Dogs",
    link:
      "https://citizenshipper.com/blog/pet-shipping-cost-estimate-cats-and-dogs/",
    imagePath: "/images/cats-and-dogs.jpeg",
    alt: "cost estimate",
  },

  {
    title: "How Much Does It Cost to Ship a Pet Across the US",
    imagePath: "/images/across-the-us.webp",
    alt: "across-the-us",
    link:
      "https://citizenshipper.com/blog/how-much-does-it-cost-to-ship-a-pet-across-the-us/",
  },

  {
    title: "Cost to Ship a Pet in Cargo",
    imagePath: "/images/ship-a-pet.png",
    alt: "across state lines",
    link:
      "https://citizenshipper.com/blog/cost-to-ship-a-pet-across-state-lines/",
  },
  {
    title: "How Do I Prepare My Dog for Flight Cargo",
    imagePath: "/images/flight-cargo.webp",
    alt: "flight cargo",
    link:
      "https://citizenshipper.com/blog/how-do-i-prepare-my-dog-for-flight-cargo/",
  },
  {
    title: "Breeders guide to puppy shipping",
    imagePath: "/images/puppy-shipping.webp",
    alt: "puppy shipping",
    link: "https://citizenshipper.com/blog/breeders-guide-to-puppy-shipping/",
  },
  {
    title: "Become an Animal Transporter",
    imagePath: "/images/become-transporter.webp",
    alt: "become a transporter",
    link: "https://citizenshipper.com/blog/become-an-animal-transporter/",
  },
]

type LinkType = { title: string; imagePath: string; alt: string; link: string }
const shuffledLinks: LinkType[] = shuffleArray(links).slice(0, 6)

export default function PetShippingBlogLinks() {
  return (
    <section id="PetShippingBlogLinks" className="my-8">
      <h2 className="max-w-prose mb-6 mx-auto text-blue7 text-3xl text-center font-montserrat">
        Ship. Stay. Enjoy!
      </h2>
      <p className="max-w-prose text-lg text-center mx-auto">
        We're here to help your pet have a safe, stress-free and comfortable
        journey. Check out our recent articles for useful travel tips.
      </p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-auto max-w-[1200px] px-4">
        {shuffledLinks.map(({ title, imagePath, link, alt }, index) => (
          <Anchor
            key={index}
            href={link}
            passHref
            className={`hover:no-underline mx-auto ${
              index >= 3 && index < 4 ? "hidden md:block" : ""
            } ${index >= 4 ? "hidden lg:block" : ""}`}
            target="_blank"
          >
            <section className="w-full max-w-[320px] h-auto rounded-lg bg-gray3 overflow-hidden hover:drop-shadow-card flex flex-col">
              <div className="w-full relative" style={{ aspectRatio: "16/9" }}>
                <Image
                  src={imagePath}
                  alt={alt}
                  fill
                  sizes="(max-width: 320px) 100vw, 320px"
                  className="object-cover"
                />
              </div>
              <div className="p-4 flex-grow flex items-start">
                <h3 className="font-medium text-lg text-black hover:no-underline line-clamp-3">
                  {title}
                </h3>
              </div>
            </section>
          </Anchor>
        ))}
      </div>
    </section>
  )
}
